export const SUBWAY_STATION_EXTENTS_VERSION = 1;
